import { withProps } from 'recompose'
import React from 'react'
import Markdown from 'react-markdown'

import { getVenueContent } from '../app/selectors'
import content from '../content'

const VenuePage = ({ mapLink, mapImage, text, text2 }) => (
  <div>
    <Markdown source={text} />
    <div>
      <a href={mapLink} target="_blank" style={{ width: '100%' }}>
        <img src={mapImage} alt="map" style={{ width: '100%' }} />
      </a>
    </div>
    <Markdown source={text2} />
  </div>
)

const programContent = getVenueContent(content)

const withPageContent = withProps({
  mapLink: programContent.mapLink,
  mapImage: programContent.mapImage,
  text: programContent.text,
  text2: programContent.text2,
})

export default withPageContent(VenuePage)



// WEBPACK FOOTER //
// ./src/containers/VenuePage.js